module.exports = __webpack_public_path__ + "static/media/error.315675dc.svg";